import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { trackingPageNumbersReducer } from './tracking-page-numbers.reducer';
import { TrackingPageNumbersEffects } from './tracking-page-numbers.effects';
import { TrackingPageNumbersDataSerivce } from './tracking-page-numbers-data.service';
import { TrackingPageNumbersFacade } from './tracking-page-numbers.facade';

@NgModule({
  imports: [
    StoreModule.forFeature('trackingPageNumbers', trackingPageNumbersReducer),
    EffectsModule.forFeature([TrackingPageNumbersEffects])
  ],
  providers: [TrackingPageNumbersDataSerivce, TrackingPageNumbersFacade]
})
export class TrackingPageNumbersStoreModule {}
